import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? match[1] : null;
        if (!sessionId) {
            navigate("/wmwe/hub", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await axios.post(
                    `${API}/auth/google-session`,
                    { session_id: sessionId },
                    { withCredentials: true }
                );
                setUser(data.user);
            } catch (e) {
                console.error("Session exchange failed:", e);
            } finally {
                // Strip the hash and navigate to hub
                window.history.replaceState(null, "", "/wmwe/hub");
                navigate("/wmwe/hub", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen bg-sanct-cream flex items-center justify-center">
            <p className="font-serif italic text-2xl text-sanct-cocoa">Welcoming you in…</p>
        </div>
    );
}
